import React, { useCallback, useRef, useState } from 'react';
import { MoveHorizontalIcon } from 'lucide-react';
type Props = {
  before: string;
  after: string;
  beforeAlt: string;
  afterAlt: string;
};
export function BeforeAfter({
  before,
  after,
  beforeAlt,
  afterAlt
}: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState(55);
  const [dragging, setDragging] = useState(false);
  const setFromClientX = useCallback((clientX: number) => {
    const box = containerRef.current?.getBoundingClientRect();
    if (!box || box.width === 0) return;
    const next = (clientX - box.left) / box.width * 100;
    setPosition(Math.min(100, Math.max(0, next)));
  }, []);
  const onPointerDown = (e: React.PointerEvent) => {
    setDragging(true);
    e.currentTarget.setPointerCapture(e.pointerId);
    setFromClientX(e.clientX);
  };
  const onPointerMove = (e: React.PointerEvent) => {
    if (!dragging) return;
    setFromClientX(e.clientX);
  };
  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'ArrowLeft') setPosition(p => Math.max(0, p - 4));
    if (e.key === 'ArrowRight') setPosition(p => Math.min(100, p + 4));
  };
  return <div ref={containerRef} className="relative aspect-[4/3] w-full max-w-full touch-pan-y select-none overflow-hidden rounded-2xl border border-edge sm:aspect-[16/9]" onPointerDown={onPointerDown} onPointerMove={onPointerMove} onPointerUp={() => setDragging(false)} onPointerCancel={() => setDragging(false)} data-id="element-315" data-mp="t5b79npk9m7k">
      <img src={after} alt={afterAlt} className="absolute inset-0 h-full w-full object-cover" draggable={false} data-id="element-316" data-mp="9galu9hw7uky" />

      <img src={before} alt={beforeAlt} className="absolute inset-0 h-full w-full object-cover" style={{
      clipPath: `inset(0 ${100 - position}% 0 0)`
    }} draggable={false} data-id="element-317" data-mp="o5ghxolfp4om" />

      <span className="pointer-events-none absolute left-3 top-3 rounded-full bg-void/70 px-3 py-1.5 text-[11px] uppercase tracking-[0.16em] text-chalk" data-id="element-318" data-mp="3rqvz5pxzfovq">
        Voor
      </span>
      <span className="pointer-events-none absolute right-3 top-3 rounded-full bg-ember/90 px-3 py-1.5 text-[11px] uppercase tracking-[0.16em] text-void" data-id="element-319" data-mp="1qq7tvbi36xua">
        Na
      </span>

      <div className="pointer-events-none absolute inset-y-0 w-px bg-ember" style={{
      left: `${position}%`
    }} aria-hidden="true" data-id="element-320" data-mp="20hlu5lhv41oh" />

      <button type="button" role="slider" aria-label="Vergelijk voor en na" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(position)} onKeyDown={onKeyDown} className="absolute top-1/2 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 cursor-ew-resize items-center justify-center rounded-full bg-ember text-void" style={{
      left: `${position}%`
    }} data-id="element-321" data-mp="17s51cmqbyirq">
        <MoveHorizontalIcon className="h-5 w-5" aria-hidden="true" data-id="element-322" data-mp="2s6xaiqy1sdb9" />
      </button>
    </div>;
}